package com.appsyde.shared.modules.account.domain.usecase

import com.appsyde.shared.modules.account.domain.model.RequestDeletionResult
import com.appsyde.shared.modules.account.domain.repository.AccountRepository

class RequestAccountDeletionUseCase(
    private val accountRepository: AccountRepository
) {
    suspend operator fun invoke(): RequestDeletionResult = accountRepository.requestAccountDeletion()
}
